import {SpreadsheetNewPageDto} from './SpreadsheetNewPageDto';
import {SpreadsheetPageRemoveDto} from './SpreadsheetPageRemoveDto';

export class SpreadsheetSaveDto {
    public constructor(
        public TableId: number, public EntityRecordId: number,
        public NewPages: SpreadsheetNewPageDto[], public RemovedPages: SpreadsheetPageRemoveDto[],
        public Paged: boolean) {
    }
}